import React from 'react';
import { BrowserRouter as Router, Navigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, Slide } from 'react-toastify';
import RoutesConfig from './routes/RoutesConfig';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <RoutesConfig />
        <ToastContainer
          position="top-center"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeButton={false}
          pauseOnFocusLoss={false}
          pauseOnHover
          draggable
          theme="colored"
          transition={Slide}
          style={{
            top: '80px'  // Offset from the top (adjust this value as needed)
          }}
        />
      </Router>
    </AuthProvider>
  );
}

export default App;
